import i18n from 'i18next';

import detectLanguage from './languageDetector';

const initializeDetectedLanguage = () => {
  const language = detectLanguage();
  i18n.changeLanguage(language);
  return language;
};

export default initializeDetectedLanguage;
